import React, { useState } from 'react';
import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import oAuthService from './services/oAuthService';
import pkceChallenge from 'pkce-challenge'
import UserMenu from 'app/theme-layouts/shared-components/UserMenu';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { Box } from '@mui/system';
import jwtDecode from 'jwt-decode';

const pkce = () => {
    return pkceChallenge(128);
}

const Redirect = () => {
    const [searchParams] = useSearchParams();
    const [serverError, setServerError] = useState(false);
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();


    const handleClose = () => {
        setOpen(false);
    }

    const authenticate = async () => {
        const isAuthenticated = await oAuthService.authenticate();
        const token = localStorage.getItem("token") && jwtDecode(localStorage.getItem("token"));
        if (isAuthenticated && token?.scope?.includes('ROLE_MD')) {
            //if (localStorage.getItem('currentUrl') && JSON.parse(localStorage.getItem('currentUrl'))[token?.email]) {
            //    navigate(JSON.parse(localStorage.getItem('currentUrl'))[token?.email])
            //} else {
                navigate('/dashboard');
            //}
        } else if( (isAuthenticated && token?.scope?.includes('ROLE_PARTNRORDPROCESS')) || (isAuthenticated && token.scope.includes("ROLE_PARTNER_ADMIN"))|| (isAuthenticated && token.scope.includes("ROLE_SHWRMMGR"))) {
            navigate('/order/order-list');
        }else if( (isAuthenticated &&( token?.scope?.includes('ROLE_LOGIMGR')) || (isAuthenticated && token.scope.includes("ROLE_LOGISTICS")))) {
            navigate('/container-list');
        }else if( (isAuthenticated &&token?.scope?.includes('ROLE_FACTORY_QA') )) {
            navigate('/reports/ao-analysis');
        }
        else if( (isAuthenticated && token?.scope?.includes('ROLE_ORDERPRO')) || (isAuthenticated && token.scope.includes("ROLE_SOPDIR"))) {
            navigate('/order/dashboard');
        }
        else if (isAuthenticated) {

            //if (localStorage.getItem('currentUrl') && JSON.parse(localStorage.getItem('currentUrl'))[token?.email]) {
            //    navigate(JSON.parse(localStorage.getItem('currentUrl'))[token?.email])
            //} else {
                navigate('/dashboard');
            //}
        } else {
            setServerError(true);
            setOpen(true);
        }
    }

    useEffect(() => {
        const token = localStorage.getItem("token") && jwtDecode(localStorage.getItem("token"));
        if (localStorage.getItem('access_token')) {
            //if (localStorage.getItem('currentUrl') && JSON.parse(localStorage.getItem('currentUrl'))[token?.email]) {
            //    navigate(localStorage.getItem('currentUrl'))
            //} else {
                navigate('/dashboard');
            //}
            return;
        }

        if (searchParams.get('code')) {
            if (localStorage.getItem('code_verifier')) {
                localStorage.setItem('code', searchParams.get('code'));
                authenticate();
            } else {
                const pkcePair = pkce();
                localStorage.setItem('code_verifier', pkcePair['code_verifier']);
                localStorage.setItem('code', pkcePair['code_challenge']);
                const AuthorizationUrl = oAuthService.authorize(pkcePair['code_challenge']);
                window.location = AuthorizationUrl;
                authenticate();
            }

        } else if (!searchParams.get('code')) {
            const pkcePair = pkce();
            localStorage.setItem('code_verifier', pkcePair['code_verifier']);
            const AuthorizationUrl = oAuthService.authorize(pkcePair['code_challenge']);
            window.location = AuthorizationUrl
        }
    }, []);
    return (
        <>
            {serverError ?
                <>
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogContent sx={{ width: "600px", height: "auto", alignItems: "center" }}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <ErrorIcon sx={{ height: "90px", width: "90px", color: "#ffc107" }} />
                            </Box>
                            <DialogContentText id="alert-dialog-description" align="center">
                                <Typography variant="h5">Please try after some time. Redis server is down or is under maintenance.</Typography>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>

                            <Button onClick={handleClose} autoFocus>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                </> :
                <p>Redirecting...</p>
            }

        </>
    )
}

export default Redirect;